import useSWR from "swr";

import { api } from 'api';

function useTeamStandings(year = 'current') {

    const { data, error, isLoading } = useSWR(
        ['team-standings', year],
        () => api.team.getTeamList(year).then(res => res.data)
    );

    return {
        teamStandings: data,
        isLoading,
        isError: !!error
    }
}

export default useTeamStandings;
